import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiUsers, FiMail, FiPhone, FiBookOpen, FiChevronRight } from 'react-icons/fi';
import api from '../../api/config';
import './gmincele.css'; // Ortak kullanılan ana kurumsal CSS
import './ArsivBasvurular.css'; // Sekme özelleştirmeleri için

const ArsivBasvurular = () => {
  const [activeTab, setActiveTab] = useState('merkez');
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const tabs = [
    { key: 'merkez',        label: 'Genel Merkez' },
    { key: 'yurt-personel', label: 'Yurt Personel' },
    { key: 'yurt-yonetici', label: 'Yurt Yönetici' },
    { key: 'neva-yemek',    label: 'Neva Yemek' },
  ];

  useEffect(() => {
    fetchJobs(activeTab);
  }, [activeTab]);

  const fetchJobs = async (type) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(`/api/arsiv/basvurular/${type}`);
      const data = response.data;

      if (!data || !data.ilanlar) {
        setJobs([]);
        setSelectedJob(null);
        return;
      }

      const jobsWithDetails = await Promise.all((data.ilanlar || []).map(async (job) => {
        const basvuranlarWithDetails = await Promise.all((job.basvuranlar || []).map(async (applicant) => {
          let cvData = null;
          let photoUrl = null;

          try {
            const cvResponse = await api.get(`/api/cv/${applicant.user_id}`);
            cvData = cvResponse.data?.[0] || null;
          } catch (cvErr) {
            console.error(cvErr);
          }

          try {
            const photoResponse = await api.get(`/api/photo/${applicant.user_id}`, { responseType: 'blob' });
            photoUrl = URL.createObjectURL(photoResponse.data);
          } catch {}

          return { ...applicant, cv: cvData, photoUrl };
        }));
        return { ...job, basvuranlar: basvuranlarWithDetails };
      }));

      setJobs(jobsWithDetails);
      
      // Sekme değiştiğinde arşivlenmiş ilk ilanı otomatik seç
      if (jobsWithDetails.length > 0) {
        setSelectedJob(jobsWithDetails[0]);
      } else {
        setSelectedJob(null);
      }
    } catch (error) {
      console.error('Arşiv başvuruları alınamadı:', error);
      setError('Arşiv verileri yüklenirken bir sorun oluştu.');
    } finally {
      setLoading(false);
    }
  };

const handleApplicantClick = (applicant) => {
    navigate(`/basvuru-detay/${applicant.user_id}`, {
        state: { 
            applicantData: applicant,
            kaynakTab: 'arsivBasvuru' 
        }
    });
};

  if (loading) {
    return (
      <div className="corporate-loader-container">
        <div className="corp-loader"></div>
        <span>Arşiv Kayıtları Yükleniyor...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="corp-dashboard">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="corp-dashboard">
      {/* Üst Başlık Alanı */}
      <div className="corp-header-bar">
        <div>
          <h1>Arşiv Başvuruları</h1>
          <p className="subtitle">Kapatılmış ve Arşivlenmiş İlanların Başvuru Geçmişi</p>
        </div>
      </div>

      {/* Kurumsal Departman Sekmeleri */}
      <div className="arsiv-tab-container">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`arsiv-tab-button ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* İlan Seçim Seçici */}
      <div className="corp-filter-section">
        <label htmlFor="job-select"><FiBriefcase /> Arşivlenmiş İlan Seçimi:</label>
        <select 
          id="job-select"
          value={selectedJob?.ilan_detay?.id || ''} 
          onChange={(e) => {
            const job = jobs.find(j => j.ilan_detay.id === parseInt(e.target.value));
            setSelectedJob(job);
          }}
          disabled={jobs.length === 0}
        >
          {jobs.length === 0 ? (
            <option>Bu kategoriye ait arşivlenmiş ilan bulunamadı</option>
          ) : (
            jobs.map(job => (
              <option key={job.ilan_detay.id} value={job.ilan_detay.id}>
                {job.ilan_detay.ilan_basligi} ({job.basvuranlar?.length || 0} Başvuru)
              </option>
            ))
          )}
        </select>
      </div>

      {/* Başvuru Satır Listesi */}
      <div className="corp-content-card">
        {selectedJob ? (
          <>
            <div className="panel-meta">
              <div className="meta-title">
                <h2>{selectedJob.ilan_detay.ilan_basligi}</h2>
                <span className="corp-badge bg-gray">{selectedJob.ilan_detay.sehir}</span>
              </div>
              <div className="meta-stats">
                <FiUsers /> <span><strong>{selectedJob.basvuranlar?.length || 0}</strong> Eski Başvuru</span>
              </div>
            </div>

            {!selectedJob.basvuranlar || selectedJob.basvuranlar.length === 0 ? (
              <div className="corp-empty-state">Bu arşiv ilanına yapılmış bir başvuru kaydı bulunamadı.</div>
            ) : (
              <div className="corp-list">
                {/* Liste Başlığı */}
                <div className="corp-list-header">
                  <div className="col-name">Aday Adı Soyadı</div>
                  <div className="col-contact">İletişim Bilgileri</div>
                  <div className="col-edu">Eğitim Durumu</div>
                  <div className="col-exp">Son Deneyim</div>
                  <div className="col-action"></div>
                </div>

                {/* Aday Satırları */}
                {selectedJob.basvuranlar.map((applicant) => {
                  const lastExp = applicant.is_deneyimleri?.[0];
                  return (
                    <div 
                      key={applicant.user_id} 
                      className="corp-list-item"
                      onClick={() => handleApplicantClick(applicant)}
                    >
                      <div className="col-name font-semibold">
                        {applicant.ad} {applicant.soyad}
                      </div>
                      
                      <div className="col-contact contact-details">
                        <span><FiMail /> {applicant.email}</span>
                        <span><FiPhone /> {applicant.cep_telefonu}</span>
                      </div>
                      
                      <div className="col-edu">
                        <span className="corp-tag-edu">
                          <FiBookOpen /> {applicant.mezuniyet || '-'}
                        </span>
                      </div>
                      
                      <div className="col-exp truncate-text">
                        {lastExp ? (
                          <span><strong>{lastExp.firma_adi}</strong> ({lastExp.pozisyon})</span>
                        ) : (
                          <span className="text-gray-light">Deneyim Yok</span>
                        )}
                      </div>
                      
                      <div className="col-action">
                        <button className="corp-view-btn">
                          İncele <FiChevronRight />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ) : (
          <div className="corp-empty-state">Arşiv verilerini listelemek için aktif bir ilan seçimi olmalıdır.</div>
        )}
      </div>
    </div>
  );
};

export default ArsivBasvurular;